import React from 'react'

export default function Modal({ isOpen, setIsOpen, title, children }) {
    const changeIsOpen = () => {
        setIsOpen(!isOpen)
    }
    return (
        <>
            <div id={Date.now()} class={isOpen ? "fixed top-0 left-0 right-0 z-[60] items-center justify-center w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full flex" : "hidden fixed top-0 left-0 right-0 z-[60] items-center justify-center w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full"}>
                <div class="relative w-full max-w-2xl max-h-full z-[60]">
                    <div class="relative bg-white rounded-3xl shadow">
                        <div class="flex items-start justify-between px-6 pt-3 pb-2 rounded-t-3xl border-t-4 border-sky-400 shadow-md">
                            <h3 class="text-xl font-semibold text-gray-900 ">
                                {title}
                            </h3>
                            <button onClick={changeIsOpen} type="button" class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center ">
                                <svg class="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                                </svg>
                                <span class="sr-only">Close</span>
                            </button>
                        </div>
                        {children}
                    </div>
                </div>
                {isOpen && <div onClick={changeIsOpen} class="bg-gray-900/50  fixed inset-0 z-50"></div>}

            </div>

        </>
    )
}
